module.exports = __webpack_public_path__ + "static/media/groupwareTechnology.b24f7fc5.png";